type FabNavigateProps = {
    className?: string;
    size?: number;
    fill?: string;
};

const FabNavigate = ({className, size = 22, fill = 'currentColor'}: FabNavigateProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="28 28 24 24"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden
    >
        <path d="M36.7915 35.4167C36.7915 35.838 36.8745 36.2552 37.0357 36.6445C37.197 37.0337 37.4333 37.3874 37.7312 37.6853C38.0291 37.9833 38.3828 38.2196 38.7721 38.3808C39.1613 38.5421 39.5785 38.625 39.9998 38.625C40.4211 38.625 40.8384 38.5421 41.2276 38.3808C41.6168 38.2196 41.9706 37.9833 42.2685 37.6853C42.5664 37.3874 42.8027 37.0337 42.964 36.6445C43.1252 36.2552 43.2082 35.838 43.2082 35.4167C43.2082 34.9954 43.1252 34.5782 42.964 34.1889C42.8027 33.7997 42.5664 33.446 42.2685 33.1481C41.9706 32.8502 41.6168 32.6138 41.2276 32.4526C40.8384 32.2914 40.4211 32.2084 39.9998 32.2084C39.5785 32.2084 39.1613 32.2914 38.7721 32.4526C38.3828 32.6138 38.0291 32.8502 37.7312 33.1481C37.4333 33.446 37.197 33.7997 37.0357 34.1889C36.8745 34.5782 36.7915 34.9954 36.7915 35.4167Z" />
        <path d="M40 29.4584C41.6667 29.4586 43.265 30.1209 44.4434 31.2994C45.6218 32.478 46.2838 34.0764 46.2838 35.743C46.2838 38.6901 41.7536 45.996 40.386 48.1336C40.3445 48.1983 40.2874 48.2516 40.2199 48.2885C40.1526 48.3254 40.0769 48.3447 40 48.3447C39.9232 48.3447 39.8476 48.3254 39.7801 48.2885C39.7127 48.2516 39.6556 48.1983 39.6141 48.1336C38.2465 45.996 33.7163 38.692 33.7163 35.743C33.7162 34.9178 33.8786 34.1006 34.1944 33.3381C34.5101 32.5756 34.9729 31.8828 35.5565 31.2992C36.14 30.7156 36.8327 30.2526 37.5952 29.9368C38.3576 29.6209 39.1748 29.4584 40 29.4584Z" />
        <path d="M44.5835 47.0583C48.1108 47.3553 50.5418 47.9833 50.5418 48.7083C50.5418 49.7213 45.8228 50.5417 40.0002 50.5417C34.1775 50.5417 29.4585 49.7213 29.4585 48.7083C29.4585 47.9842 31.8739 47.3581 35.3783 47.0583" />
    </svg>
);

export default FabNavigate;
